export const blogsFAQ = [
    {
        blogTitle: "Static QR Codes vs Dynamic QR Codes: Learn the Differences",
        faq: [
            {
                "@type": "Question",
                name: "What's the primary difference between static and dynamic QR codes?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "The main difference lies in their flexibility. Static QR codes contain fixed information that cannot be changed after creation. Dynamic QR codes, on the other hand, allow you to update the linked content, making them more adaptable for situations that require changes or updates.",
                },
            },
            {
                "@type": "Question",
                name: "In what scenarios would I use a static QR code?",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: "Static QR codes are ideal when the linked content is not likely to change. For instance, if you want to provide a permanent link to your website or contact details on a business card, a static QR code is suitable because these details typically remain constant.",
                },
            },
        ],
    },
];
